import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { useMemo } from 'react';
import { GoogleSheetCreateModal } from '../../../Google/Sheets/UseGoogleSheetCreate/GoogleSheetCreateModal';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const GoogleSheetCreateModalWidget = () => {
    const component = useMemo(() => (_jsx(Stack, { direction: "row", children: _jsx(GoogleSheetCreateModal, { setCreatedSheetFile: (file) => {
                // do something with the created file
            } }) })), []);
    return {
        name: 'GoogleSheetCreateModal',
        category: 'composite',
        component,
    };
};
